export default {
  custom: () => import("/home/runner/work/solo-brands-scaffolding/solo-brands-scaffolding/webapp/layouts/custom.vue"),
  default: () => import("/home/runner/work/solo-brands-scaffolding/solo-brands-scaffolding/webapp/layouts/default.vue")
}